/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.docking

/**
 * User: luc
 * Date: Jun 1, 2006
 * Time: 10:57:57 AM
 */
class DockingType private constructor(private val myText: String) {
    override fun toString(): String {
        return myText
    }

    companion object {
        val DOCKED = DockingType("docked")
        val FLOATING = DockingType("floating")
        val SLIDING = DockingType("sliding")
    }
}